import {AxiosPromise} from 'axios';
import {apiCaller} from '@/api/apiCaller';
import {apihost} from '@/api/urls';
import {
  DncClientContractFilter,
  DncFamilyFilter,
  DncFamilyGroupFailsFilter,
  DncFamilyGroupFilter,
} from '@/modules/neovehicle/models/filters';
import {
  DncClientContract,
  DncFamily,
  DncFamilyGroup,
  DncFamilyGroupFails,
  DncFamilyGroupFamily,
} from '@/modules/neovehicle/models/dnc';
import {CountryEnum} from '@/models/Enums';
import {buildDownloadFile} from '@/modules/neovehicle/services/services';

const getDncFamily = (filter: DncFamilyFilter): AxiosPromise<DncFamily[]> =>
  apiCaller.getParams(`/neovehicle/dnc/families`, apihost, filter);

const getDncFamilyGroups = (filter: DncFamilyGroupFilter): AxiosPromise<DncFamilyGroup[]> =>
  apiCaller.getParams(`/neovehicle/dnc/familygroups`, apihost, filter);

const getDncClientContracts = (filter: DncClientContractFilter): AxiosPromise<DncClientContract[]> =>
  apiCaller.getParams(`/neovehicle/dnc/clientcontracts`, apihost, filter);

const getDncFamilyGroupFails = (filter: DncFamilyGroupFailsFilter): AxiosPromise<DncFamilyGroupFails[]> =>
  apiCaller.getParams(`/neovehicle/dnc/familygroupfails`, apihost, filter);

const saveDncFamilyGroupFamily = (payload: DncFamilyGroupFamily): AxiosPromise<void> =>
    apiCaller.post(
      `/neovehicle/dnc/familygroupfamilies`,
      apihost,
      payload,
    );

const saveDncFamilyGroup = (payload: DncFamilyGroup): AxiosPromise<void> =>
  apiCaller.post(
    `/neovehicle/dnc/familygroups`,
    apihost,
    payload,
  );


const exportDncFamilyGroups = (country: CountryEnum): Promise<any> =>
  apiCaller
    .getFile(`/neovehicle/dnc/familygroups/export?country=${country}`, apihost)
    .then(
      buildDownloadFile(
        `relatorio_dnc_familia_grupos_${new Date().toISOString()}.xlsx`,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ),
    );

export const dncFamilyService = {
  getDncFamily,
  getDncFamilyGroups,
  getDncClientContracts,
  getDncFamilyGroupFails,
  saveDncFamilyGroupFamily,
  saveDncFamilyGroup,
  exportDncFamilyGroups,
};
